<!-- Mobile Overlay -->
<div class="mobile-overlay"
     [class.active]="mobileSidebarOpen"
     (click)="closeMobileSidebar()">
</div>

<!-- Sidebar -->
<aside class="layout-sidebar"
       [class.collapsed]="sidebarCollapsed && !isMobile"
       [class.mobile-open]="mobileSidebarOpen">

    <!-- Sidebar Header -->
    <div class="sidebar-header">
        <div class="sidebar-logo-wrapper">
            <img src="assets/images/logo/adhivasindo-logo.webp" alt="Adhivasindo" class="sidebar-logo-img" />
        </div>
        <div class="sidebar-brand">
            <span class="sidebar-brand-name">Avia</span>
            <span class="sidebar-brand-label">Super Apps</span>
        </div>
    </div>

    <!-- Navigation -->
    <nav class="sidebar-nav">
        <div class="sidebar-nav-label">MENU UTAMA</div>

        <ng-container *ngFor="let item of filteredNavItems; trackBy: trackByNavId">
            <!-- Item tanpa children (Single link) -->
            <a *ngIf="!item.children || item.children.length === 0"
               class="sidebar-nav-item"
               [routerLink]="item.route"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
               (click)="onNavItemClick()"
               [title]="sidebarCollapsed ? item.label : ''">
                <span class="material-icons sidebar-nav-icon">{{ item.icon }}</span>
                <span class="sidebar-nav-text">{{ item.label }}</span>
            </a>

            <!-- Item dengan children (Dropdown Accordion) -->
            <div *ngIf="item.children && item.children.length > 0" class="sidebar-nav-group" [class.open]="isSubmenuOpen(item)">
                <button type="button"
                        class="sidebar-nav-item sidebar-nav-item--parent"
                        [class.active]="isItemActive(item)"
                        (click)="toggleSubmenu(item, $event)"
                        [title]="sidebarCollapsed ? item.label : ''">
                    <span class="material-icons sidebar-nav-icon">{{ item.icon }}</span>
                    <span class="sidebar-nav-text">{{ item.label }}</span>
                    <span class="material-icons sidebar-nav-arrow" [class.rotated]="isSubmenuOpen(item)">expand_more</span>
                </button>

                <div class="sidebar-submenu" *ngIf="isSubmenuOpen(item) && !sidebarCollapsed">
                    <a *ngFor="let child of item.children; trackBy: trackByNavId"
                       class="sidebar-nav-item sidebar-submenu-item"
                       [routerLink]="child.route"
                       [class.active]="isChildActive(child)"
                       (click)="onNavItemClick()"
                       [title]="child.label">
                        <span class="material-icons sidebar-submenu-icon">{{ child.icon }}</span>
                        <span class="sidebar-nav-text">{{ child.label }}</span>
                    </a>
                </div>
            </div>
        </ng-container>
    </nav>

    <!-- Sidebar Footer (Collapse Toggle) -->
    <div class="sidebar-footer">
        <button type="button"
                class="sidebar-collapse-btn"
                (click)="toggleSidebar()"
                [title]="sidebarCollapsed ? 'Perluas Sidebar' : 'Ciutkan Sidebar'">
            <span class="material-icons sidebar-collapse-icon">
                {{ sidebarCollapsed ? 'chevron_right' : 'chevron_left' }}
            </span>
            <span class="sidebar-collapse-text">Ciutkan Menu</span>
        </button>
    </div>
</aside>

<!-- Main Area -->
<div class="layout-main">
    <!-- Header -->
    <header class="layout-header">
        <button class="header-toggle" (click)="toggleSidebar()" title="Toggle Sidebar">
            <span class="material-icons">menu</span>
        </button>

        <div class="header-breadcrumb">
            <span>Avia</span>
            <span>/</span>
            <span class="header-breadcrumb-current">{{ currentBreadcrumb }}</span>
        </div>

        <div class="header-spacer"></div>

        <div class="header-actions">
            <!-- Theme Slide Toggle (Light / Dark) -->
            <button class="theme-slide-toggle"
                    [class.dark]="isDark$ | async"
                    (click)="toggleScheme()"
                    [title]="(isDark$ | async) ? 'Beralih ke Mode Terang' : 'Beralih ke Mode Gelap'"
                    aria-label="Toggle Dark Mode">
                <div class="toggle-track">
                    <span class="material-icons toggle-icon sun-icon">light_mode</span>
                    <span class="material-icons toggle-icon moon-icon">dark_mode</span>
                    <div class="toggle-thumb">
                        <span class="material-icons thumb-icon" *ngIf="!(isDark$ | async)">light_mode</span>
                        <span class="material-icons thumb-icon" *ngIf="isDark$ | async">dark_mode</span>
                    </div>
                </div>
            </button>

            <button class="header-action-btn" title="Notifications">
                <span class="material-icons">notifications_none</span>
                <div class="header-notification-dot"></div>
            </button>

            <!-- User Profile Dropdown Menu -->
            <div class="header-user-menu">
                <button type="button"
                        class="header-user-trigger"
                        (click)="toggleUserDropdown($event)"
                        [class.active]="userDropdownOpen"
                        aria-label="Menu Profil Pengguna"
                        [attr.aria-expanded]="userDropdownOpen"
                        title="{{ userName }} ({{ userRole }})">
                    <div class="header-user-avatar">
                        <img *ngIf="userAvatar" [src]="userAvatar" [alt]="userName" class="header-user-avatar-img" (error)="userAvatar = ''">
                        <span *ngIf="!userAvatar">{{ userInitials }}</span>
                    </div>
                    <div class="header-user-meta">
                        <span class="header-user-name">{{ userName }}</span>
                        <span class="header-user-role">{{ userRole }}</span>
                    </div>
                    <span class="material-icons header-user-chevron" [class.rotated]="userDropdownOpen">expand_more</span>
                </button>

                <!-- Dropdown Popover -->
                <div class="user-dropdown-card" *ngIf="userDropdownOpen" (click)="$event.stopPropagation()">
                    <!-- User Identity Header -->
                    <div class="user-dropdown-header">
                        <div class="user-dropdown-avatar">
                            <img *ngIf="userAvatar" [src]="userAvatar" [alt]="userName" class="user-dropdown-avatar-img" (error)="userAvatar = ''">
                            <span *ngIf="!userAvatar">{{ userInitials }}</span>
                        </div>
                        <div class="user-dropdown-info">
                            <span class="user-dropdown-name" [title]="userName">{{ userName }}</span>
                            <span class="user-dropdown-email" [title]="userEmail">{{ userEmail }}</span>
                            <div class="user-dropdown-badge-wrap">
                                <span class="user-dropdown-role-badge">{{ userRole }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="user-dropdown-divider"></div>

                    <!-- Navigation Items -->
                    <div class="user-dropdown-list">
                        <a class="user-dropdown-item" [routerLink]="['/profile']" (click)="closeUserDropdown()">
                            <span class="material-icons user-dropdown-icon">person_outline</span>
                            <div class="user-dropdown-text">
                                <span class="user-dropdown-label">Profil Saya</span>
                                <span class="user-dropdown-desc">Kelola biodata & info akun</span>
                            </div>
                            <span class="material-icons user-dropdown-item-arrow">chevron_right</span>
                        </a>

                        <a class="user-dropdown-item" [routerLink]="['/self-service']" (click)="closeUserDropdown()">
                            <span class="material-icons user-dropdown-icon">assignment_ind</span>
                            <div class="user-dropdown-text">
                                <span class="user-dropdown-label">Portal Pengajuan</span>
                                <span class="user-dropdown-desc">Cuti, lembur & reimbursement</span>
                            </div>
                            <span class="material-icons user-dropdown-item-arrow">chevron_right</span>
                        </a>
                    </div>

                    <div class="user-dropdown-divider"></div>

                    <!-- Footer Action (Logout) -->
                    <div class="user-dropdown-footer">
                        <button type="button" class="user-dropdown-logout-btn" (click)="onLogout()">
                            <span class="material-icons">logout</span>
                            <span>Keluar dari Akun</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!-- Content -->
    <main class="layout-content">
        <router-outlet></router-outlet>
    </main>
</div>
